// extracted by mini-css-extract-plugin
export default {"background":"home_background__txL2N","title":"home_title__3sAC4","logo":"home_logo__QvEtq","home-container":"home_home-container__Zc7oE"};